import { UploadField } from 'payload'
import { FieldWithouType } from '@utils/fields'
import { mergeObjects } from '@utils/objects'
import { SimpleUploadField } from '@components/(payload)/fields/upload/simple-upload';

/**
 * Creates a simple Upload Field.
 * Will not open a modal
 *
 * @param config
 * @returns
 */
export function simpleUploadField(config: WithOneRequired<FieldWithouType<CustomPayloadField<UploadField>>, 'relationTo'>): CustomPayloadField<UploadField>[] {
  const configDefault: Omit<SimpleUploadField, 'type' | 'name' | 'relationTo'> = {
    hasMany: false,
    displayPreview: false,
  };

  const configRequired: Omit<SimpleUploadField, 'name' | 'relationTo'> = {
    type: 'upload',
    admin: {
      components: {
        Field: {
          path: '@components/(payload)/fields/upload/simple-upload',
          clientProps: {}
        }
      }
    },
  };

  const field: CustomPayloadField<UploadField> = mergeObjects(mergeObjects(configDefault, config), configRequired);
  return [ field ];
}
